import { render, staticRenderFns } from "./BankInfo.vue?vue&type=template&id=b8903ccc&scoped=true"
import script from "./BankInfo.vue?vue&type=script&lang=js"
export * from "./BankInfo.vue?vue&type=script&lang=js"
import style0 from "./BankInfo.vue?vue&type=style&index=0&id=b8903ccc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8903ccc",
  null
  
)

export default component.exports